import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";

export default class Debriefing {
    constructor() {
        this.elms = {
            submitDebrief: "#submitDebrief",
            finishDebrief: "#finishDebrief",
            form: ".js-debriefing-form",
            debriefingItems: ".debriefing__wrap",
            nextDebrief: ".next-debrief-btn",
            backDebrief: ".back-debrief-btn",
            questionItem: ".debriefing__item",
            questionWrapper: ".question",
            debriefItem: ".debriefing__item",
        };

        this.slickOpts = {
            arrows: false,
            swipe: false,
            centerMode: true,
            dots: false,
            loops: false,
            infinite: false,
        };

        this.isLoading = false;
        return this;
    }

    init() {
        const elms = this.elms;

        // @ts-ignore
        $(elms.debriefingItems).slick(this.slickOpts);
        $(elms.form).on("submit", this._onFormSubmited.bind(this));
        $(elms.backDebrief).on("click", this._goToPreviousItem.bind(this));
        $(elms.finishDebrief).on("click", this._finishDebriefing.bind(this));

        $(elms.form).on(
            "change",
            'input[type="radio"]',
            this._removeErrorState,
        );
        $(elms.form).on(
            "input",
            ['input[type="text"]', 'input[type="email"]'].join(","),
            this._removeErrorState,
        );
    }

    _finishDebriefing() {
        if (this.isLoading) return;

        $(".resultPage").removeClass("is-debriefing");
    }

    _removeErrorState(e) {
        const $el = $(e.currentTarget);
        const $questionAnswer = $el.parents(".question").first();

        $questionAnswer.removeClass(["has-error", "has-validation-error"]);
    }

    _goToPreviousItem() {
        $(this.elms.debriefingItems).slick("slickPrev");
    }

    _onFormSubmited(e) {
        // prettier-ignore
        // eslint-disable-next-line
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        const elms = this.elms;
        const $this = $(e.currentTarget);
        const $questionItem = $this.parents(elms.questionItem);
        const $wrapper = $this.find(elms.questionWrapper);
        const questionType = $questionItem.data("type-question");
        const inputType = $questionItem.find("input").attr("type");
        const slick = $(elms.debriefingItems).slick("getSlick");
        const isLastSlide = slick.currentSlide === slick.slideCount - 1;
        let isAnswered = true;

        if (questionType !== "plain_text") {
            let answer = "";

            if (inputType === "text" || inputType === "email") {
                answer = String($questionItem.find("input").val());
            } else {
                answer = String(
                    $questionItem.find("input[type=radio]:checked").val() ?? "",
                );
            }

            if (answer.trim() === "" || answer === "undefined") {
                isAnswered = false;
                $wrapper.addClass("has-error");
            } else if (inputType === "email") {
                const isValidEmail = emailRegex.test(answer);
                $wrapper.toggleClass("has-validation-error", !isValidEmail);
                isAnswered = isValidEmail;
            }
        }

        if (isAnswered === true) {
            $wrapper.removeClass(["has-error", "has-validation-error"]);

            if (isLastSlide) {
                this._submitDebriefing();
            } else {
                $(elms.debriefingItems).slick("slickNext");
            }
        }
        return false;
    }

    async _submitDebriefing() {
        const elms = this.elms;
        const $submitBtn = $('button[type="submit"]');
        $(elms.debriefItem).find("button").prop("disabled", true);
        $(elms.debriefItem).find("input").prop("readonly", true);
        if (this.isLoading) return;

        $submitBtn.addClass("is-loading");
        this.isLoading = true;

        const $questions = $(elms.questionItem);
        const answers = [];

        $.each($questions, function (index, question) {
            const $question = $(question);
            const questionID = $question.attr("data-id");
            const questionType = $question.attr("data-type-question");
            const answerText = $question
                .find("input[type=text], input[type=email]")
                .val();
            const answerChoice = $question
                .find("input[type=radio]:checked")
                .val();

            if (questionType !== "plain_text") {
                answers.push({
                    question_id: questionID,
                    answer: answerText || answerChoice,
                });
            }
        });

        const [res] = await bdjs.goAsync(
            bdapi.post("game/submit-debriefing", {
                answers: answers,
            }),
        );

        const resData = res?.data || {};

        if (resData?.success) {
            $submitBtn.prop("disabled", true);
            $(".resultPage").removeClass("is-debriefing");
        }

        $submitBtn.removeClass("is-loading");
        this.isLoading = false;

        $(elms.debriefItem).find("button[disabled]").prop("disabled", false);
        $(elms.debriefItem).find("input[readonly]").prop("readonly", false);
        $(elms.debriefItem).find("input[type='radio']").prop("checked", false);
        $(elms.debriefItem)
            .find("input[type='text'], input[type='email']")
            .val("");

        $(elms.debriefingItems).slick("slickGoTo", 0);

        return false;
    }
}
